/* eleReady Function */
(function (win) {
  'use strict';
  var listeners = [], doc = win.document,
      MutationObserver = win.MutationObserver || win.WebKitMutationObserver,
      observer;

  function ready(selector, fn) {
    listeners.push({ selector: selector, fn: fn });
    if (!observer) {
      observer = new MutationObserver(check);
      observer.observe(doc.documentElement, { childList: true, subtree: true });
    }
    check();
  }

  function check() {
    for (var i = 0, len = listeners.length, listener, elements; i < len; i++) {
      listener = listeners[i];
      elements = doc.querySelectorAll(listener.selector);
      for (var j = 0, jLen = elements.length, element; j < jLen; j++) {
        element = elements[j];
        if (!element.__eleReadyDone) {
          element.__eleReadyDone = true; 
          listener.fn.call(element, element);
        }
      }
    }
  }

  win.eleReady = ready;
})(this);


// Utility: Wait for element to appear
function waitForElement(selector, callback) {
  const interval = setInterval(() => {
    const el = document.querySelector(selector);
    if (el) {
      clearInterval(interval);
      callback(el);
    }
  }, 100);
}


/******************************************
 * Main Code Execution *
 ******************************************/
window.requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame || function (timeOutFn) {
  return setTimeout(timeOutFn, 1000 / 60);
};

window['CP_MS_PLP_Mobile_32'] = function () {

  const gridSelector = '.products-carousel, .products-grid';
  const cardSelector = '.products-carousel .product .card, .products-grid .product .card';

  const productGrid = document.querySelector(gridSelector);
  if (productGrid) {

      eleReady(cardSelector, function (productEl) {

          // Add plus ATC button
          const cardMedia = productEl.querySelector(".card-media");
          if (cardMedia && !cardMedia.querySelector(".CP-plusAtc-btn")) {
              const actionButtonHTML = `
                <div class="CP-plusAtc-btn">
                  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="11" cy="11" r="11" fill="#FCF6EC"></circle><path d="M10.064 15.36V12.112H6.896V10.704H10.064V7.552H11.536V10.704H14.704V12.112H11.536V15.36H10.064Z" fill="#6E1D1C"></path></svg>
                </div>`;
              cardMedia.insertAdjacentHTML("beforeend", actionButtonHTML);
          }



          /* SAFE RATING BLOCK (No Errors, No Crashes) */
          const cardInformationWrapper = productEl.querySelector('div.card-information__wrapper');
          if (cardInformationWrapper) {

              const cardHeading = cardInformationWrapper.querySelector('h3.card__heading');
              const judgeWidget = cardInformationWrapper.querySelector('div.jdgm-widget');

              if (cardHeading && judgeWidget) {

                  const ratingSpanEl = judgeWidget.querySelector('span.jdgm-all-reviews-rating');
                  const rating2 = ratingSpanEl?.getAttribute('data-score');
                  const rating = (Number(rating2) || 4.3).toFixed(1);

                  const ratingWrapper = document.createElement('div');
                  ratingWrapper.classList.add('CP-product-ratings-wrapper');

                  const rateSpan = document.createElement('span');
                  rateSpan.innerText = rating;

                  const starSvg = `
                    <svg width="7" height="7" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.33875 7L1.9075 4.41184L0 2.67105L2.52 2.44079L3.5 0L4.48 2.44079L7 2.67105L5.0925 4.41184L5.66125 7L3.5 5.62763L1.33875 7Z" fill="white"></path></svg>`;

                  ratingWrapper.appendChild(rateSpan);
                  ratingWrapper.insertAdjacentHTML("beforeend", starSvg);

                  const headingAnchor = cardHeading.querySelector('a.card-title');
                  if (headingAnchor) headingAnchor.style.marginLeft = "0px";

                  cardHeading.appendChild(ratingWrapper);

                  judgeWidget.remove();
              }
          }

      });
  }



  /* Delegated click + keyboard handler for Plus ATC */
  function handlePlusAtcTrigger(btn) {
    const root =
      btn.closest(".product-item") ||
      btn.closest(".card") ||
      btn.closest("[data-product], .grid__item, .product");

    if (!root) return;

    //const realAtcButton = root.querySelector('[data-quickshop-popup], [data-btn-addtocart]') || document.querySelector('[data-quickshop-popup], [data-btn-addtocart]');
    const realAtcButton = root.querySelector('.button-ATC');

    if (realAtcButton) realAtcButton.click();

    const card = root.querySelector(".card") || btn.closest(".card");
    if (card) card.classList.add("quickshop-popup-show");

    if (window.innerWidth <= 767) {
      document.documentElement.classList.add("quick_shop_popup_mobile");
    }
  }

  document.addEventListener("click", (e) => {
    const plusBtn = e.target.closest(".CP-plusAtc-btn");
    if (plusBtn) {
      e.preventDefault();
      handlePlusAtcTrigger(plusBtn);
      return;
    }

    if (
      e.target.closest(".background-overlay, #halo-card-mobile-popup .mobile-popup-header .close-modal, #halo-cart-sidebar .halo-sidebar-close")
    ) {
      document.documentElement.classList.remove("quick_shop_popup_mobile");
    }
  });

  document.addEventListener("keydown", (e) => {
    if ((e.key === "Enter" || e.key === " ") && e.target.closest(".CP-plusAtc-btn")) {
      e.preventDefault();
      handlePlusAtcTrigger(e.target.closest(".CP-plusAtc-btn"));
    }
  });

};

window.CP_MS_PLP_Mobile_32();
